import { Loader2 } from "lucide-react";
export default function LoadingScreen({ label = "Loading…" }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] gap-3 text-gray-500">
      <Loader2 className="w-6 h-6 animate-spin text-[#538135]" />
      <span className="text-sm">{label}</span>
    </div>
  );
}
